module.exports = __webpack_public_path__ + "img/illustrator-invitations.svg";